module.exports = __webpack_public_path__ + "static/media/dundeeunilogo.671761f9.png";